import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { inject, PropType, ref } from "vue";
import { IUmbracoFormField } from "@/models/umbraco-forms/IUmbracoFormField";
import UmbracoFormInput from "@/components/umbraco-forms/inputs/UmbracoFormInput.vue";
import { IUmbracoFormUserPreValues } from "@/models/umbraco-forms/IUmbracoFormUserPreValues";
import { UmbracoFormParseMagicString } from "@/code/UmbracoFormExtensions";


export default /*#__PURE__*/_defineComponent({
  __name: 'UmbracoFormHidden',
  props: {
  field: {
    type: Object as PropType<IUmbracoFormField>,
    required: true,
  },
},
  setup(__props) {

const props = __props;


const value = ref<string>();
const prevalues = inject<IUmbracoFormUserPreValues>("prevalues");
if (prevalues) {
  value.value = UmbracoFormParseMagicString(prevalues, props.field?.settings.defaultValue);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UmbracoFormInput, {
    field: __props.field,
    type: "hidden",
    value: value.value
  }, null, 8, ["field", "value"]))
}
}

})